import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatDateToDayMonthYearTime } from '@/utils/dateFormatters';

interface BundleModalProps {
  open: boolean;
  onClose: () => void;
  onApprove: () => void;
  title: string;
  amount: number;
  createdAt: string;
}

const BundleModal = ({
  open,
  onClose,
  onApprove,
  title,
  amount,
  createdAt
}: BundleModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('bundle.purchase.confirmation')}</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {t('amount')}: {amount}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {t('created.at')}: {formatDateToDayMonthYearTime(createdAt)}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('cancel')}</Button>
        <Button onClick={onApprove} variant="contained" color="primary">
          {t('approve')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BundleModal;
